(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[73921],{

/***/ 53276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(646);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96119);



// import SharedButton from "@components/severalbrands/sharedButton";


const HeroSection = ()=>{
    const { category  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    // const getTitle = () => {
    //     const fallbackStaticTitle =
    //         "Expand Your Client Base with <span style={{ whiteSpace: 'nowrap' }}>High-Intent</span> MVA Leads";
    //     if (!genericPage) {
    //         return fallbackStaticTitle;
    //     } else {
    //         const textBlockContent = domain?.textBlocks?.find(
    //             (el) => el.position === "severalbrands-main-title",
    //         );
    //         return textBlockContent
    //             ? textBlockContent.text
    //             : formattedTitle
    //             ? formattedTitle
    //             : fallbackStaticTitle;
    //     }
    // };
    // const getDescription = () => {
    //     const fallbackStaticDescription =
    //         "Discover how our tailored car accident lead generation solutions can transform your case intake. Get a consultation by completing the form below!";
    //     if (!genericPage) {
    //         return fallbackStaticDescription;
    //     } else {
    //         const textBlockContent = domain?.textBlocks?.find(
    //             (el) => el.position === "severalbrands-main-description",
    //         );
    //         return textBlockContent
    //             ? textBlockContent.text
    //             : fallbackStaticDescription;
    //     }
    // };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().bgStyle)} ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[category?.slug]}`,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().innerContainerStyle),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["main-banner"]),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_form__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    classes: {
                        formClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().form),
                        stepTitleClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["step-title"]),
                        stepDescriptionClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["step-description"]),
                        formButtonClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["form-button"]),
                        formFieldClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["form-field"]),
                        formStepInnerClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["steps-inner"]),
                        stepClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["step-block"]),
                        fieldsClassName: {
                            radio: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["radio-field"]),
                            checkbox: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["checkbox-field"]),
                            input: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["input-field"]),
                            multiSelect: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["multiSelect-field"]),
                            select: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["select-field"]),
                            textarea: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["text-area-field"])
                        },
                        fieldsWrapperClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["fields-wrapper"]),
                        tcpaClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().tcpa),
                        labelAsTitleClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["label-as-step-title"]),
                        formProgressbarClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["progress-background"]),
                        fieldErrorMessageClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["error-style"]),
                        formFieldLabelClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["field-label"]),
                        fieldNoteClassName: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["note-style"])
                    },
                    backButton: {
                        class: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["back-button"]),
                        label: ""
                    },
                    colors: {
                        primaryColor: "#EF4F80"
                    },
                    showProgress: true,
                    showStepNumberOnly: true,
                    searchableMultiSelect: true
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroSection);


/***/ }),

/***/ 4130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ GeneralCategoryForthSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/severalbrands/whyPartnerWithUs/index.tsx
var whyPartnerWithUs = __webpack_require__(64080);
// EXTERNAL MODULE: ./src/components/severalbrands/b2b/forthSection/unlockBusiness/style.module.scss
var style_module = __webpack_require__(38733);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./src/components/severalbrands/ourStoryPage/mainSharedComponent/index.tsx
var mainSharedComponent = __webpack_require__(62652);
;// CONCATENATED MODULE: ./src/components/severalbrands/b2b/forthSection/unlockBusiness/index.tsx



const list = [
    {
        img: "/severalbrands/assets/images/unlockBusinessSuccessB2b2.webp",
        mainTitle: "Unlock Business Success With Diverse Marketing Channels & Tactics",
        secondTitle: "SEO & SEM",
        paragraphs: [
            "While SEO offers lasting benefits and revenue growth without added expenses, it may lack scalability. To ramp up sales for our clients, we employ SEM. Our approach involves a dedicated content creation team for SEO and more than 20 SEM account managers overseeing paid media campaigns across Google, Bing, and Yahoo, guaranteeing effective and efficient digital marketing solutions.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[130px] gap-[40px] `,
        mainTitleClassName: "text-[#351C4F]",
        secondTitleClassName: "mt-[20px] text-[#37367D]",
        imgClassName: "w-[250px]  h-[250px] md:w-[420px] md:min-w-[420px] md:h-[420px] relative 3xl:w-[620px] 3xl:min-w-[620px] 3xl:h-[620px] lg:mt-10 lg:ml-16 3xl:ml-28"
    },
    {
        img: "/severalbrands/assets/images/displayAdvertisingB2b.png",
        mainTitle: "Display Advertising",
        paragraphs: [
            "We implement diverse sources in our display advertising strategies, leveraging platforms like the Google Display Network, native advertising channels such as Taboola and Outbrain, PPV advertising, and other third-party networks. With over a decade of experience, we've rigorously tested and refined our methods across these networks to deliver top-notch quality and maximize conversion metrics for our advertising campaigns.", 
        ],
        mainSectionClassName: `lg:gap-[160px] gap-[40px] lg:ml-16 3xl:ml-28 `,
        mainTitleClassName: "text-[#37367D] 3xl:mt-[60px]",
        imgToLeft: true,
        imgClassName: "w-[250px]  h-[200px] md:w-[458px] md:min-w-[458px] md:h-[312px] relative 3xl:w-[630px] 3xl:min-w-[630px] 3xl:h-[554px]"
    },
    {
        img: "/severalbrands/assets/images/localizationB2b2.webp",
        mainTitle: "Localization",
        paragraphs: [
            "Localization is a potent marketing tool, particularly for clients with global outreach or diverse language audiences. US-based law firms aiming at English- and Spanish-speaking clientele can gain substantial advantages. Likewise, software companies offering antivirus, website builders, hosting services, etc., can leverage localization to enhance both paid media and organic traffic.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[180px]  gap-[40px]  `,
        secondSectionClassName: "",
        mainTitleClassName: "text-[#37367D] lg:mt-10",
        imgClassName: "w-[250px]  h-[250px] md:w-[392px] md:min-w-[392px] md:h-[392px] 3xl:w-[592px] 3xl:min-w-[592px] 3xl:h-[592px]  relative lg:ml-16 3xl:ml-28"
    }, 
];
function UnlockBusiness({ generalList  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (style_module_default()).bgStyle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "lg:py-32 py-16 px-4 lg:px-0 ",
            children: (generalList ? generalList : list).map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lg:mt-36 mt-14 first-of-type:mt-0 ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mainSharedComponent/* default */.Z, {
                        info: el
                    })
                }, index))
        })
    });
}

;// CONCATENATED MODULE: ./src/components/severalbrands/b2b/forthSection/index.tsx



const partnerWitUSData = {
    title: "Why Partner With Us?",
    paragraphs: [
        {
            text: "Partnering with us means accessing a team of experts dedicated to your success. Our data-driven approach ensures that every marketing effort resonates with your target audience, driving measurable results and sustainable growth. We help you connect with businesses that need your solutions, navigating the complexities of the B2B market with confidence.",
            className: "default"
        },
        {
            text: "Let us help you unlock your company's full potential and thrive in this competitive industry. Together, we can transform your marketing strategy into a powerful tool for success, ensuring that your B2B solutions reach the businesses that need them most.",
            className: "default"
        }, 
    ],
    buttonText: "Partner With Us"
};
function GeneralCategoryForthSection({ mainData  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UnlockBusiness, {
                generalList: mainData?.unlockBusinessContent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-32 lg:mt-56 lg:mb-48 mb-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(whyPartnerWithUs/* default */.Z, {
                    partnerWitUSData: mainData?.partnerWithUSData ? mainData?.partnerWithUSData : partnerWitUSData
                })
            })
        ]
    });
}


/***/ }),

/***/ 63305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ GeneralCategorySecondSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/severalbrands/homePage/firstSection/textImageSharedComponent/index.tsx
var textImageSharedComponent = __webpack_require__(26784);
// EXTERNAL MODULE: ./src/components/severalbrands/b2b/secondSection/strategicLeadGeneration/style.module.scss
var style_module = __webpack_require__(15791);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./src/components/severalbrands/b2b/secondSection/strategicLeadGeneration/icons/b2bLeadCultivationIcon.tsx
var b2bLeadCultivationIcon = __webpack_require__(69508);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 111 modules
var motion = __webpack_require__(76265);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useWindowSize.tsx
var useWindowSize = __webpack_require__(91173);
;// CONCATENATED MODULE: ./src/components/severalbrands/b2b/secondSection/strategicLeadGeneration/index.tsx


// import LegalSectorInsightIcon from "./icons/legalSectorInsightIcon";




// const b2bCategories = [
//     "b2b",
//     "fleet-management",
//     "business-phone-systems",
//     "crm",
//     "credit-card-processing",
//     "clinical-trials",
//     "forklifts",
//     "point-of-sale",
//     "payroll",
//     "peo",
//     "medical-software",
//     "debt-relief",
//     "sb-fleet-management",
//     "sb-business-phone-systems",
//     "sb-crm",
//     "sb-credit-card-processing",
//     "sb-clinical-trials",
//     "sb-forklifts",
//     "sb-point-of-sale",
//     "sb-payroll",
//     "sb-peo-employee-leasing",
//     "sb-medical-software",
//     "sb-debt-relief",
// ];
const strategicLeadGenerationList = [
    {
        title: "B2B Lead Cultivation",
        tabName: "B2B",
        slug: "b2b",
        description: "A shocking finding by Marketing Donut reveals that 80% of leads go unexplored, resulting in a wide expanse of lost opportunities. Our advanced methods and systems are designed to identify and cultivate genuine leads, ensuring every potential client is engaged through follow-up messages or direct calls. This approach positions us to deliver high-quality prospects to your business, enhancing customer loyalty. We have vast experience working with a wide range of industries and helping your company to serve other businesses.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(b2bLeadCultivationIcon/* default */.Z, {})
    }, 
];
const paragraphsStyle = "lg:mt-8 mt-6 font-light lg:text-lg 3xl:text-[26px] 3xl:leading-[2.5rem] text-base lg:leading-8 text-[#351C4F]";
function StrategicLeadGeneration({ mainData  }) {
    // const { category } = useDomainContext();
    const windowSize = (0,useWindowSize/* default */.Z)();
    const { 0: selectedEl , 1: setSelectedEl  } = (0,react.useState)(mainData?.list ? mainData.list[0].slug : strategicLeadGenerationList[0].slug);
    // if (category?.slug === "legal") {
    //     strategicLeadGenerationList.unshift({
    //         title: "Legal Sector Insight",
    //         tabName: "Legal",
    //         slug: "legal",
    //         description:
    //             "85% of law firms face challenges in new client acquisition, as noted by the American Bar Association. The complexity of legal terminology and the daunting nature of lawyer interactions can deter potential clients. At SeveralBrands, we excel in crafting straightforward, engaging content and advertisements that elevate client confidence, effectively targeting and securing signed retainers within our legal network with minimal drop-off rates.",
    //         icon: <LegalSectorInsightIcon />,
    //     });
    // }
    const filteredList = windowSize.width < 1024 ? [
        (mainData?.list ? mainData?.list : strategicLeadGenerationList).find((el)=>el.slug === selectedEl), 
    ] : mainData?.list ? [
        ...mainData.list
    ] : [
        ...strategicLeadGenerationList
    ];
    const showTheTabListOnMobile = strategicLeadGenerationList.length > 1 || mainData?.list && mainData?.list?.length > 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (style_module_default()).bgStyle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
            transition: {
                duration: 1.5
            },
            initial: {
                opacity: 0,
                y: 150
            },
            whileInView: {
                opacity: 1,
                y: 0
            },
            viewport: {
                once: true
            },
            className: "lg:py-32 py-16",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-[#351C4F] font-bold 3xl:text-7xl lg:text-5xl lg:leading-[4rem] text-2xl leading-9 text-center 3xl:max-w-[1415px] 3xl:leading-[5.5rem] lg:max-w-[915px] mx-auto",
                    children: mainData?.title ?? "Strategic Lead Generation: Timing Meets Precision"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: `${paragraphsStyle} text-center`,
                    children: mainData?.topDescription ?? "Our prowess in spearheading lead-generation efforts across diverse industries stems from our unique approach."
                }),
                showTheTabListOnMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-10 flex justify-center gap-8 lg:hidden",
                    children: (mainData?.list ? mainData.list : strategicLeadGenerationList).map((el)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.button */.E.button, {
                            whileHover: {
                                scale: [
                                    1,
                                    1.2,
                                    1
                                ],
                                transition: {
                                    duration: 0.8,
                                    repeat: Infinity,
                                    delay: 0.3
                                }
                            },
                            className: `block text-[#37367D] lg:text-lg lg:px-7 px-4 lg:py-2 py-1 cursor-pointer  ${el.slug === selectedEl ? "border border-[#37367D] rounded-3xl" : ""}`,
                            onClick: ()=>{
                                setSelectedEl(el.slug);
                            },
                            children: el.tabName
                        }, el.slug))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: filteredList.map((el)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: (style_module_default()).stepStyle,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: " max-w-[800px] 3xl:max-w-[1200px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-[#351C4F] text-lg lg:text-2xl 3xl:text-4xl lg:leading-10 mt-7 font-bold text-center lg:text-left",
                                            children: el.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: `${paragraphsStyle} text-center lg:text-left`,
                                            children: el.description
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: " relative 3xl:w-[310px] 3xl:h-[310px] lg:w-[230px] lg:h-[250px] w-[100px] h-[100px]",
                                    children: el.icon
                                })
                            ]
                        }, el.title))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: `${paragraphsStyle} text-center`,
                    children: mainData?.bottomDescription ?? `Outsourcing your lead generation isn't just a time saver—it's a cost-effective strategy to boost your business's growth. Partner with us for unparalleled lead generation expertise, allowing you to concentrate on perfecting your offerings and achieving outstanding results for your clients.`
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/severalbrands/b2b/secondSection/index.tsx



const maximizingConnections = {
    img: "/severalbrands/assets/images/torts.webp",
    mainTitle: "Get Results with Performance-Based Lead Generation",
    paragraphs: [
        "Companies that outsource lead generation experience a 43% increase in their sales pipeline due to specialized expertise and focused strategies. We offer comprehensive digital marketing solutions beyond SEM, SEO, and digital ads, including content marketing, social media strategies, and email campaigns tailored to your unique needs.",
        "Our performance-based model means you only pay for the results we deliver—no leads, no cost—tying your investment directly to tangible outcomes. We provide flexible partnership options, such as form leads, calls, clicks, warm transfers, sales, and scheduled appointments, allowing you to choose the best approach for your business goals. With our fast onboarding process, you can start generating leads and boosting sales immediately.", 
    ],
    showAnimation: true,
    showButton: true,
    buttonTitle: "Schedule a Call"
};
function GeneralCategorySecondSection({ mainData  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "3xl:mt-52 lg:mt-40 mt-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(textImageSharedComponent/* default */.Z, {
                    info: {
                        ...mainData?.imgTextComponentContent ? mainData?.imgTextComponentContent : maximizingConnections,
                        mainTitleClassName: "font-bold lg:text-6xl text-3xl lg:leading-[79px] 3xl:text-7xl 3xl:leading-[5.5rem] text-[#351C4F]"
                    }
                })
            }),
            !mainData?.hideStrategicLeadGenerationContent && /*#__PURE__*/ (0,jsx_runtime.jsx)(StrategicLeadGeneration, {
                mainData: mainData?.strategicLeadGenerationContent
            })
        ]
    });
}


/***/ }),

/***/ 69508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function B2BLeadCultivationIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 197 204",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                fill: "#351C4F",
                clipPath: "url(#clip0_1665_4439)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M28.003 101.65c-9.456 0-17.148-7.69-17.148-17.14s7.692-17.14 17.148-17.14c9.457 0 17.144 7.69 17.144 17.14s-7.692 17.14-17.143 17.14zm0-27.392c-5.652 0-10.253 4.6-10.253 10.252 0 5.651 4.601 10.252 10.253 10.252 5.653 0 10.254-4.6 10.254-10.252 0-5.652-4.601-10.252-10.253-10.252zM.001 139.491v-9.631c0-13.195 10.733-23.931 23.925-23.931h8.156a24.026 24.026 0 0117.466 7.573 3.445 3.445 0 01-.161 4.869 3.443 3.443 0 01-4.87-.161c-3.257-3.481-7.677-5.393-12.44-5.393h-8.156c-9.393 0-17.035 7.646-17.035 17.043v2.738l45.67-.02a3.445 3.445 0 01.005 6.889l-52.565.019.005.005zM168.277 101.65c-9.457 0-17.148-7.69-17.148-17.14s7.691-17.14 17.148-17.14 17.143 7.69 17.143 17.14-7.691 17.14-17.143 17.14zm0-27.392c-5.657 0-10.259 4.6-10.259 10.252 0 5.651 4.602 10.252 10.259 10.252s10.254-4.6 10.254-10.252c0-5.652-4.602-10.252-10.254-10.252zM143.721 139.491a3.449 3.449 0 01-3.448-3.442 3.446 3.446 0 013.443-3.446l45.669-.02v-2.723c0-9.397-7.637-17.043-17.03-17.043h-8.152a17.058 17.058 0 00-12.576 5.544 3.447 3.447 0 11-5.095-4.644 23.963 23.963 0 0117.667-7.793h8.151c13.192 0 23.92 10.736 23.92 23.931v9.612l-52.554.019.005.005zM98.053 34.281c-9.451 0-17.143-7.69-17.143-17.14S88.597 0 98.053 0c9.457 0 17.144 7.69 17.144 17.14s-7.692 17.141-17.144 17.141zm0-27.393c-5.652 0-10.253 4.601-10.253 10.253 0 5.651 4.6 10.252 10.253 10.252 5.653 0 10.254-4.6 10.254-10.252 0-5.652-4.601-10.253-10.254-10.253zM122.61 71.69a3.446 3.446 0 01-3.447-3.446v-5.759c0-9.396-7.643-17.043-17.036-17.043h-8.156c-9.388 0-17.026 7.647-17.026 17.043v5.69a3.446 3.446 0 01-3.447 3.447 3.443 3.443 0 01-3.447-3.446v-5.691c0-13.195 10.728-23.931 23.915-23.931h8.156c13.192 0 23.93 10.736 23.93 23.931v5.76a3.45 3.45 0 01-3.447 3.446h.005zM98.052 114.034c-10.787 0-19.564-8.77-19.564-19.556 0-10.784 8.777-19.555 19.564-19.555 10.786 0 19.563 8.77 19.563 19.555 0 10.786-8.777 19.556-19.563 19.556zm0-32.223c-6.988 0-12.674 5.681-12.674 12.667 0 6.987 5.686 12.668 12.674 12.668 6.987 0 12.674-5.681 12.674-12.668 0-6.986-5.682-12.667-12.674-12.667zM126.949 158.675a3.45 3.45 0 01-3.447-3.447v-7.402c0-11.391-9.266-20.66-20.654-20.66h-9.594c-11.383 0-20.649 9.269-20.649 20.66v7.402a3.446 3.446 0 01-3.447 3.447 3.446 3.446 0 01-3.447-3.447v-7.402c0-15.189 12.351-27.549 27.539-27.549h9.593c15.187 0 27.548 12.36 27.548 27.549v7.402a3.45 3.45 0 01-3.447 3.447h.005z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M98.059 167.617c-30.086 0-54.559-24.469-54.559-54.546 0-30.077 24.473-54.546 54.559-54.546s54.554 24.47 54.554 54.546c0 30.077-24.473 54.546-54.554 54.546zm0-102.198c-26.282 0-47.67 21.379-47.67 47.652s21.383 47.652 47.67 47.652c26.287 0 47.66-21.379 47.66-47.652s-21.383-47.652-47.66-47.652z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M148.965 165.172a3.424 3.424 0 01-2.436-1.012l-13.583-13.586a3.443 3.443 0 014.87-4.869l13.584 13.586a3.444 3.444 0 01-2.435 5.876v.005z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M171.197 204L136.5 169.313l20.053-20.049 34.697 34.691L171.197 204zm-24.952-34.687l24.952 24.943 10.308-10.301-24.952-24.948-10.308 10.306z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_1665_4439",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H196.281V204H0z"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (B2BLeadCultivationIcon);


/***/ }),

/***/ 88023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ GeneralCategoryThirdSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 111 modules
var motion = __webpack_require__(76265);
// EXTERNAL MODULE: ./src/components/severalbrands/b2b/thirdSection/howWeWork/style.module.scss
var style_module = __webpack_require__(56902);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./src/components/severalbrands/b2b/thirdSection/howWeWork/index.tsx



const strategicLeadGenerationList = [
    {
        description: "Our company works with your business to create a pricing strategy that aligns with your performance metrics and meets your requirements."
    },
    {
        description: "Our team conducts thorough research to generate leads tailored to your specific needs and ideal customer profile (ICP). We then create personalized campaigns targeting actual customers through comprehensive research to maximize conversions."
    },
    {
        description: "Our state-of-the-art lead verification system is designed to filter out fraud, perform syntax checks, and flag duplicates. To ensure high-quality leads, our call center team nurtures verified leads. We use keyword optimization and strategic timing to increase conversions. You can trust that we will verify each lead before promptly sending it to you."
    },
    {
        description: "We request regular reports from our clients on lead performance, including contact status and sales conversion rates. This helps us to improve lead quality and find the perfect customers for our clients."
    },
    {
        description: "We agree on KPIs with our partners for a reasonable cost per sale or opportunity and adjust payouts based on performance against these KPIs."
    },
    {
        description: "Continue following steps 2, 3, and 4 until we achieve an autopilot mode that meets our business's KPIs and satisfies everyone involved."
    }, 
];
const paragraphsStyle = "lg:mt-4 mt-2 font-light lg:text-lg 3xl:text-[26px] 3xl:leading-[2.5rem] text-base lg:leading-8 text-[#351C4F]";
function HowWeWork({ mainData  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "lg:my-32 my-16 ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.h2 */.E.h2, {
                transition: {
                    duration: 1.5
                },
                initial: {
                    opacity: 0,
                    y: 150
                },
                whileInView: {
                    opacity: 1,
                    y: 0
                },
                viewport: {
                    once: true
                },
                className: "text-[#351C4F] font-bold 3xl:text-7xl lg:text-5xl lg:leading-[4rem] text-2xl leading-9 text-center 3xl:max-w-[1415px] 3xl:leading-[5.5rem] lg:max-w-[915px] mx-auto",
                children: mainData?.title ? mainData?.title : "How We Work"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "lg:mt-16 mt-8 flex flex-wrap justify-center 3xl:gap-20 gap-6",
                children: (mainData?.list ? mainData.list : strategicLeadGenerationList).map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.li */.E.li, {
                        transition: {
                            duration: 1.5
                        },
                        initial: {
                            opacity: 0,
                            y: 150
                        },
                        whileInView: {
                            opacity: 1,
                            y: 0
                        },
                        viewport: {
                            once: true
                        },
                        className: (style_module_default()).stepStyle,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: index + 1
                            }),
                            el.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "lg:mt-8 mt-6 font-bold 3xl:text-5xl lg:text-3xl 3xl:leading-[4rem] text-xl lg:leading-10 text-[#351C4F]",
                                children: el.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: `${paragraphsStyle} ${el.title ? "" : "lg:mt-8 mt-6"}`,
                                children: el.description
                            })
                        ]
                    }, index))
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/severalbrands/howWeWorkPage/partneringWithSeveralBrands/index.tsx
var partneringWithSeveralBrands = __webpack_require__(62121);
// EXTERNAL MODULE: ./src/components/severalbrands/howWeWorkPage/partneringWithSeveralBrands/icons/costPerCallIcon.tsx
var costPerCallIcon = __webpack_require__(73760);
// EXTERNAL MODULE: ./src/components/severalbrands/howWeWorkPage/partneringWithSeveralBrands/icons/costPerClickIcon.tsx
var costPerClickIcon = __webpack_require__(59591);
// EXTERNAL MODULE: ./src/components/severalbrands/howWeWorkPage/partneringWithSeveralBrands/icons/costPerLeadIcon.tsx
var costPerLeadIcon = __webpack_require__(587);
// EXTERNAL MODULE: ./src/components/severalbrands/howWeWorkPage/partneringWithSeveralBrands/icons/costPerRetainerIcon.tsx
var costPerRetainerIcon = __webpack_require__(59535);
// EXTERNAL MODULE: ./src/components/severalbrands/howWeWorkPage/partneringWithSeveralBrands/icons/costPerSaleIcon.tsx
var costPerSaleIcon = __webpack_require__(83873);
// EXTERNAL MODULE: ./src/components/severalbrands/howWeWorkPage/partneringWithSeveralBrands/icons/revenueShareIcon.tsx
var revenueShareIcon = __webpack_require__(44444);
;// CONCATENATED MODULE: ./src/components/severalbrands/b2b/thirdSection/index.tsx









const list = [
    {
        title: "Cost Per Click",
        p: "Our comparison and review websites can drive highly qualified traffic to your offer.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(costPerClickIcon/* default */.Z, {})
    },
    {
        title: "Cost Per Sale",
        p: "Our revenue model is sales-oriented, ensuring we are compensated solely upon delivering tangible sales outcomes for your business.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(costPerSaleIcon/* default */.Z, {})
    },
    {
        title: "Cost Per Lead",
        p: "We excel at generating top-notch web form leads using targeted paid search, social media, display ads, organic SEO, and other advertising campaigns.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(costPerLeadIcon/* default */.Z, {})
    },
    {
        title: "Cost Per Call",
        p: "We assist local businesses in boosting their customer calls through our billable call service. We only charge for calls that either meet a set duration threshold or result in a conversion.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(costPerCallIcon/* default */.Z, {})
    },
    {
        title: "Performance-Based Cost Structure",
        p: "Law firms can benefit from a risk-free partnership with us. Our payment is contingent upon the signing of the retainer, either managed by your intake team or our dependable intake center.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(costPerRetainerIcon/* default */.Z, {})
    },
    {
        title: "Revenue Share",
        p: "Under this model, we produce top-tier leads for your business, and you compensate us solely based on a percentage of the revenue derived from those leads.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(revenueShareIcon/* default */.Z, {})
    }, 
];
function GeneralCategoryThirdSection({ mainData  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HowWeWork, {
                mainData: {
                    list: mainData?.howWeWorkContent?.list,
                    title: mainData?.howWeWorkContent?.title
                }
            }),
            !mainData?.hideHowWeWorkContent && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-32",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(partneringWithSeveralBrands/* default */.Z, {
                    list: mainData?.howWeHelpContent?.list ? mainData?.howWeHelpContent?.list : list,
                    mainTitle: mainData?.howWeHelpContent?.mainTitle ? mainData?.howWeHelpContent?.mainTitle : "How We Help Your Business Attract More Customers",
                    benefitListClassName: mainData?.howWeHelpContent?.benefitListClassName,
                    benefitItemClassName: mainData?.howWeHelpContent?.benefitItemClassName
                })
            })
        ]
    });
}


/***/ }),

/***/ 26784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TextImageSharedComponent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16893);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32233);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76265);
/* harmony import */ var _components_severalbrands_sharedButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81467);
/* harmony import */ var _hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91173);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);


// import { Player } from "@lottiefiles/react-lottie-player";
// import dynamic from "next/dynamic";
// const Player = dynamic(
//     () => import("@lottiefiles/react-lottie-player").then((mod) => mod.Player),
//     {
//         ssr: false,
//     },
// );




function TextImageSharedComponent({ info  }) {
    const mainSectionDevRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const isInView = (0,framer_motion__WEBPACK_IMPORTED_MODULE_5__/* .useInView */ .Y)(mainSectionDevRef, {
        once: true
    });
    const windowSize = (0,_hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const mainEl = (0,framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .useAnimation */ ._)();
    const firstEl = (0,framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .useAnimation */ ._)();
    const secondEl = (0,framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .useAnimation */ ._)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isInView) {
            mainEl.start("visible").catch(()=>{});
            firstEl.start("visible").catch(()=>{});
            secondEl.start("visible").catch(()=>{});
        }
    }, [
        isInView
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_7__/* .motion.section */ .E.section, {
        ref: mainSectionDevRef,
        variants: {
            visible: info.showAnimation ? {
                y: [
                    150,
                    0
                ],
                opacity: [
                    0,
                    1
                ]
            } : {}
        },
        animate: mainEl,
        transition: {
            duration: 1.5
        },
        className: `flex flex-col lg:flex-row items-center ${info.imgToLeft ? "justify-end" : ""} gap-8 lg:gap-[80px] 3xl:gap-[200px]  `,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_7__/* .motion.div */ .E.div, {
                variants: {
                    visible: windowSize.width < 1024 ? {
                        y: [
                            150,
                            0
                        ],
                        opacity: [
                            0,
                            1
                        ]
                    } : {
                    }
                },
                transition: {
                    duration: 1.5
                },
                animate: firstEl,
                className: `max-w-[700px]  3xl:max-w-[1000px]  mx-auto lg:mx-0  ${info.mainDivTextMarginTop ? info.mainDivTextMarginTop : ""}  ${info.imgToLeft ? "order-2 " : "order-2 lg:order-1"}`,
                children: [
                    info.mainTitle && (info.mainH1Element ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: info.mainTitleClassName ? info.mainTitleClassName : "font-bold lg:text-6xl text-3xl lg:leading-[79px] 3xl:text-[5.5rem] 3xl:leading-[6.5rem] text-[#351C4F] ",
                        children: info.mainTitle
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: info.mainTitleClassName ? info.mainTitleClassName : "font-bold lg:text-6xl text-3xl lg:leading-[79px] 3xl:text-[5.5rem] 3xl:leading-[6.5rem] text-[#351C4F] ",
                        children: info.mainTitle
                    })),
                    info.secondTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: " font-semibold text-2xl lg:text-4xl 3xl:text-5xl 3xl lg:leading-[45px] 3xl:leading-[3.5rem] mt-2 3xl:mt-4 text-[#351C4F]",
                        children: info.secondTitle
                    }),
                    info.paragraphs && info.paragraphs?.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: info.paragraphs?.map((pInfo, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: info.paragraphsClassName ? info.paragraphsClassName : "lg:mt-8 mt-6 font-light lg:text-lg 3xl:text-[26px] 3xl:leading-[2.5rem] text-base lg:leading-8 ",
                                children: pInfo
                            }, index))
                    }),
                    info.showButton && (info.buttonTitle ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "lg:mt-12 mt-7 w-fit mx-auto lg:mx-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_sharedButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            regularButton: true,
                            scrollButton: true,
                            children: info.buttonTitle
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "lg:mt-12 mt-7 w-fit mx-auto lg:mx-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_sharedButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            href: "/key-considerations",
                            children: info.guideButtonTitle || "Claim Your Free Guide"
                        })
                    }))
                ]
            }),
            info.img && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_7__/* .motion.div */ .E.div, {
                variants: {
                    visible: windowSize.width < 1024 ? {
                        y: [
                            150,
                            0
                        ],
                        opacity: [
                            0,
                            1
                        ],
                        transition: {
                            duration: 1.5
                        }
                    } : {}
                },
                animate: secondEl,
                className: `${info.imgClassName ? info.imgClassName : ""}  w-[250px]  h-[250px] md:w-[392px] md:min-w-[392px] md:h-[392px] 3xl:w-[592px] 3xl:min-w-[592px] 3xl:h-[592px]  relative mx-auto lg:mx-0  ${info.imgToLeft ? "order-1" : "order-1 lg:order-2"}`,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                    src: info.img,
                    alt: "img",
                    layout: "fill",
                    objectFit: "contain"
                })
            })
        ]
    });
}


/***/ }),

/***/ 73760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function CostPerCallIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "57",
        height: "57",
        fill: "none",
        viewBox: "0 0 57 57",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "57",
                height: "57",
                fill: "#37367D",
                rx: "5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#fff",
                d: "M32.435 31.42a2.166 2.166 0 00-2.645 1.21 4.662 4.662 0 00-.071.178c-2.88-1.231-5.29-3.64-6.52-6.52.06-.023.119-.046.178-.072a2.169 2.169 0 001.21-2.645C22.158 16 22.094 16 21.314 16A5.321 5.321 0 0016 21.315c0 10.306 8.385 18.692 18.691 18.692a5.321 5.321 0 005.316-5.316c0-.78 0-.843-7.572-3.27zM29.49 20.287a6.236 6.236 0 016.229 6.229.857.857 0 101.715 0c0-4.38-3.564-7.944-7.944-7.944a.857.857 0 100 1.715z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#fff",
                d: "M28.006 24.137a3.871 3.871 0 013.866 3.866.857.857 0 101.715 0 5.587 5.587 0 00-5.581-5.581.857.857 0 100 1.715z"
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (CostPerCallIcon);


/***/ }),

/***/ 59591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function CostPerClickIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "57",
        height: "57",
        fill: "none",
        viewBox: "0 0 57 57",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "57",
                height: "57",
                fill: "#37367D",
                rx: "5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#fff",
                d: "M42 28.4c-.01.382-.242.71-.638.901l-4.954 2.417 4.34 4.341a.381.381 0 010 .54l-4.15 4.149a.38.38 0 01-.538 0l-4.34-4.342-2.418 4.957c-.19.395-.52.627-.9.637h-.027c-.445 0-.829-.275-.938-.675l-4.628-17.26c-.106-.4-.021-.762.238-1.02.255-.256.627-.343 1.02-.239l17.257 4.63c.41.108.687.505.676.965zm-19.16 2.394c-1.575-.2-3.001-.901-4.124-2.026a7.061 7.061 0 01-2.083-5.027c0-1.9.74-3.686 2.084-5.03 2.772-2.772 7.283-2.772 10.055 0a7.052 7.052 0 012.025 4.126.817.817 0 001.62-.207 8.672 8.672 0 00-2.49-5.073c-3.41-3.41-8.956-3.41-12.365 0A8.69 8.69 0 0015 23.741c0 2.336.91 4.531 2.562 6.183a8.652 8.652 0 005.07 2.49.817.817 0 00.207-1.62zm3.409-9.556c.24.238.442.508.603.803a.816.816 0 101.433-.782 5.18 5.18 0 00-8.201-1.177 5.142 5.142 0 00-1.515 3.659c0 1.382.538 2.682 1.515 3.659.35.35.746.647 1.176.883a.815.815 0 001.108-.324.817.817 0 00-.323-1.109 3.55 3.55 0 01-.806-.605 3.519 3.519 0 01-1.037-2.504c0-.946.368-1.836 1.037-2.505a3.546 3.546 0 015.01.002z"
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (CostPerClickIcon);


/***/ }),

/***/ 587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function CostPerLeadIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "57",
        height: "57",
        fill: "none",
        viewBox: "0 0 57 57",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "57",
                height: "57",
                fill: "#37367D",
                rx: "5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#fff",
                d: "M17 25.276l4.019 4.049 4.408-4.439V42.49h5.698V24.886l4.408 4.439 4.02-4.049L28.275 14 17 25.276z"
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (CostPerLeadIcon);


/***/ }),

/***/ 59535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function CostPerRetainerIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "57",
        height: "57",
        fill: "none",
        viewBox: "0 0 57 57",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "57",
                height: "57",
                fill: "#37367D",
                rx: "5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#fff",
                d: "M26.965 35.008l4.657 3.998c.419.36.957.501 1.42.382.225-.068.666-.195.613-1.121l-4.716-3.94a.732.732 0 01-.098-1.046.74.74 0 011.054-.097l5.92 4.94a1.055 1.055 0 001.383-1.592l-5.808-5.247a.754.754 0 01-.052-1.061.745.745 0 011.054-.053l5.808 5.255c.164.15.299.322.418.508.225.075.606.083.823-.15.246-.26.755-.948.202-1.823-.397-.62-6.22-6.996-10.121-11.212l-3.028 2.556a3.106 3.106 0 01-4.223-.216 3.097 3.097 0 01-.045-4.261c.539-.583 1.181-1.263 1.824-1.929h-7.534v11.355l9.567 8.498c.733.658 1.675.994 2.564.92.538-.045.83-.21 1.01-.389l-3.663-3.14a.747.747 0 11.971-1.136z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#fff",
                d: "M23.34 24.049c.59.598 1.547.65 2.19.112l3.572-3.02a.754.754 0 011.032.068c1.39 1.502 7.31 7.915 9.747 10.711.254-.21.508-.523.747-.822.374-.464.755-.935 1.241-1.211v-10.95c-1.39.03-4.305-.06-6.69-1.144-2.78-1.271-6.899-.89-8.192.306-.105.097-.224.202-.336.314a.723.723 0 01-.456.441c-.942.927-2.034 2.085-2.878 2.99a1.609 1.609 0 00.022 2.205zM12.688 17a.686.686 0 00-.688.688v12.797c0 .38.306.687.688.687h1.644a.686.686 0 00.688-.688V17.689a.686.686 0 00-.688-.688h-1.644zM43.363 17.688v12.797c0 .38.307.687.688.687h1.644a.686.686 0 00.688-.688V17.689a.686.686 0 00-.688-.688h-1.644a.686.686 0 00-.688.688z"
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (CostPerRetainerIcon);


/***/ }),

/***/ 83873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function CostPerSaleIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "57",
        height: "57",
        fill: "none",
        viewBox: "0 0 57 57",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "57",
                height: "56.174",
                fill: "#37367D",
                rx: "5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#fff",
                d: "M34.063 21.475H23.438S16 27.86 16 35.313c0 4.256 3.198 6.386 5.312 6.386h14.876c2.123 0 5.312-2.13 5.312-6.386 0-7.452-7.438-13.838-7.438-13.838zM29.81 36.269v1.704H27.69v-1.699c-1.564-.29-2.547-1.258-2.617-2.662h1.84c.09.737.832 1.212 1.905 1.212.989 0 1.69-.481 1.69-1.166 0-.583-.454-.915-1.57-1.165l-1.184-.254c-1.657-.346-2.472-1.211-2.472-2.601s.925-2.392 2.396-2.721V25.2H29.8v1.719c1.436.32 2.393 1.302 2.44 2.622h-1.777c-.09-.72-.76-1.2-1.678-1.2-.919 0-1.582.442-1.582 1.136 0 .562.434.874 1.5 1.112l1.097.233c1.829.385 2.617 1.166 2.617 2.59 0 1.524-.977 2.544-2.606 2.856zM33.842 15.051h-2.938A3.201 3.201 0 0028.527 14a3.217 3.217 0 00-2.376 1.051h-2.939a1.07 1.07 0 00-.876.464 1.055 1.055 0 00-.11.982l.986 2.779h10.63l.987-2.78a1.052 1.052 0 00-.49-1.32 1.07 1.07 0 00-.497-.125z"
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (CostPerSaleIcon);


/***/ }),

/***/ 44444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function RevenueShareIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "57",
        height: "57",
        fill: "none",
        viewBox: "0 0 57 57",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "57",
                height: "57",
                fill: "#37367D",
                rx: "5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#fff",
                fillRule: "evenodd",
                d: "M35.73 26.238h-8.396A1.341 1.341 0 0126 24.898v-.983c0-.442.217-.836.55-1.08a6.545 6.545 0 004.984 2.297c1.993 0 3.78-.89 4.984-2.297.332.244.55.638.55 1.08v.984c-.001.736-.602 1.339-1.337 1.339zm-19.484 7.01l4.818 8.536a.866.866 0 01-.325 1.175l-1.638.93a.862.862 0 01-1.172-.326l-4.818-8.535a.866.866 0 01.325-1.175l1.638-.93a.862.862 0 011.172.326zm-1.2 1.11a.586.586 0 10.17 1.16.586.586 0 00-.17-1.16zm2.667-.615l3.4 6.024.727-.42 7.688 2.065c1.106.297 2.172.157 3.147-.445l10.6-6.544c1.509-.931.842-5.01-3.698-2.359l-5.841 3.41a3.756 3.756 0 01-.899.383c-.485.748-1.512 1.098-2.36.876-1.26-.334-2.518-.675-3.778-1.013a.517.517 0 01.267-1c1.251.337 2.5.677 3.753 1.01.821.116 1.404-.288 1.622-1.101.235-.88-.304-1.746-1.168-2.027-2.326-.42-4.607-1.396-6.005-1.85-1.253-.407-2.412.062-3.552.724l-3.903 2.267zM31.533 13c-3.057 0-5.535 2.484-5.535 5.548 0 3.065 2.478 5.549 5.534 5.549 3.057 0 5.534-2.485 5.534-5.55 0-3.063-2.478-5.547-5.534-5.547zm2.105 3.662a.516.516 0 11-.953.4c-.24-.573-.84-.814-1.425-.696-.426.086-.827.373-.804.853.027.56.716.725 1.164.8 1.027.168 2.049.596 2.19 1.767.006.05.01.108.012.176.024 1.04-.843 1.632-1.773 1.788v.308a.518.518 0 11-1.034 0v-.318c-.846-.164-1.544-.714-1.759-1.576a.516.516 0 111.001-.247c.15.599.767.854 1.336.84a2.05 2.05 0 00.2-.015c.407-.05 1.012-.25 1-.756a.925.925 0 00-.008-.079c-.074-.616-.822-.786-1.33-.87-.99-.162-1.972-.629-2.027-1.77-.048-.987.672-1.702 1.588-1.904v-.326a.518.518 0 111.034 0v.318c.726.153 1.299.618 1.588 1.307zm-3.935 14.533h6.027c.669 0 1.227.5 1.321 1.145l-3.634 2.122c.12-1.263-.695-2.446-1.925-2.846-.526-.17-1.212-.259-1.79-.421zm6.027-4.31c.735 0 1.336.603 1.336 1.34v.983c0 .737-.602 1.339-1.336 1.339h-8.037c-.468-.166-.935-.34-1.403-.507a1.333 1.333 0 01-.291-.832v-.984c0-.736.6-1.339 1.335-1.339h8.396z",
                clipRule: "evenodd"
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (RevenueShareIcon);


/***/ }),

/***/ 62121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PartneringWithSeveralBrands; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68081);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76265);



function PartneringWithSeveralBrands({ list , mainTitle , benefitListClassName , benefitItemClassName  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_1__/* .motion.section */ .E.section, {
        transition: {
            duration: 1.5
        },
        initial: {
            opacity: 0,
            y: 150
        },
        whileInView: {
            opacity: 1,
            y: 0
        },
        viewport: {
            once: true
        },
        className: `lg:mt-32 mt-16 `,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "font-bold text-[#37367D] 3xl:text-7xl lg:text-5xl lg:leading-[4rem] text-2xl leading-9 text-center 3xl:max-w-[1415px] 3xl:leading-[5.5rem] lg:max-w-[915px] mx-auto",
                children: mainTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: `flex  flex-wrap  lg:mt-12 mt-8 lg:gap-10 gap-5 justify-center  ${benefitListClassName ?? ""}`,
                children: list.map((el, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_1__/* .motion.li */ .E.li, {
                        transition: {
                            duration: 1.5
                        },
                        initial: {
                            opacity: 0,
                            y: 150
                        },
                        whileInView: {
                            opacity: 1,
                            y: 0
                        },
                        viewport: {
                            once: true
                        },
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().benefitItemStyle)} ${benefitItemClassName ?? ""} `,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: el.icon
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "text-[#37367D]  text-lg lg:text-2xl 3xl:text-4xl lg:leading-10 mt-7 font-bold",
                                children: el.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "3xl:text-2xl 3xl:leading-10 lg:text-lg lg:leading-8 mt-3 font-light",
                                children: el.p
                            })
                        ]
                    }, index))
            })
        ]
    });
}


/***/ }),

/***/ 62652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MainSharedComponent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76265);
/* harmony import */ var _components_severalbrands_sharedButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81467);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41681);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_5__);






function MainSharedComponent({ info , domainInfo  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .motion.section */ .E.section, {
        transition: {
            duration: 1.5
        },
        initial: {
            opacity: 0,
            y: 150
        },
        whileInView: {
            opacity: 1,
            y: 0
        },
        viewport: {
            once: true
        },
        className: `flex flex-col lg:flex-row  ${info.mainSectionClassName ? info.mainSectionClassName : ""} `,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: ` ${info.img ? "3xl:max-w-[800px] max-w-[500px]" : ""} mx-auto lg:mx-0 ${info.imgToLeft ? "order-2 lg:order-2" : "order-2 lg:order-1"} ${info.secondSectionClassName ? info.secondSectionClassName : ""}`,
                children: [
                    info.mainH1Element ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: `font-bold 3xl:text-5xl lg:text-3xl 3xl:leading-[4rem] text-xl lg:leading-10 text-[#351C4F] ${info.mainTitleClassName ? info.mainTitleClassName : ""} `,
                        children: info.mainTitle
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: `font-bold 3xl:text-5xl lg:text-3xl 3xl:leading-[4rem] text-xl lg:leading-10 text-[#351C4F] ${info.mainTitleClassName ? info.mainTitleClassName : ""} `,
                        children: info.mainTitle
                    }),
                    info.secondTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: `3xl:text-4xl lg:text-2xl text-lg font-bold ${info.secondTitleClassName ? info.secondTitleClassName : ""}`,
                        children: info.secondTitle
                    }),
                    info.paragraphs?.map((pInfo, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: `3xl:mt-6 lg:mt-4 mt-3 3xl:text-3xl 3xl:leading-[3rem] lg:text-xl  text-base lg:leading-8 font-light ${info.textClassName ? info.textClassName : ""}`,
                            children: pInfo
                        }, index)),
                    info.showButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-9",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_sharedButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            pdf: true,
                            href: "https://cdn.severalbrands.com/attachments/2025/02/severalbrands_resources.pdf",
                            children: "Download Your Free PDF"
                        })
                    }),
                    info.showLogos && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                        className: `flex 3xl:mt-10 mt-5 justify-center gap-10 flex-wrap`,
                        children: domainInfo?.config?.sliderLogos?.default?.map((logo)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: `w-[100px] h-[22px]  3xl:w-[150px] 3xl:h-[34px] relative ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default().imgStyle)}`,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    src: logo.path,
                                    alt: logo.slug,
                                    layout: "fill",
                                    objectFit: "contain"
                                })
                            }, logo.slug))
                    })
                ]
            }),
            info.img && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${info.imgClassName ? info.imgClassName : ""}   mx-auto lg:mx-0  ${info.imgToLeft ? "order-1 lg:order-1" : "order-1 lg:order-2"}`,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                    src: info.img,
                    alt: "img",
                    layout: "fill",
                    objectFit: "contain"
                })
            })
        ]
    });
}


/***/ }),

/***/ 81467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SharedButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57772);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_1__);


function SharedButton({ children , href , pdf , regularButton =false , onCLick , scrollButton =false  }) {
    const scrollToTop = ()=>{
        window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    };
    const buttonClassName = `  text-white  py-3 sm:px-16 px-7 sm:text-lg 3xl:text-2xl font-bold rounded-lg cursor-pointer block w-fit ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_1___default().btnStyle)}`;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: regularButton ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
            onClick: scrollButton ? scrollToTop : onCLick,
            className: buttonClassName,
            children: children
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: href,
            target: pdf ? "_blank" : "_self",
            rel: "noreferrer",
            className: buttonClassName,
            children: children
        })
    });
}


/***/ }),

/***/ 64080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WhyPartnerWithUs; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16893);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32233);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76265);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12658);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _sharedButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81467);





function WhyPartnerWithUs({ partnerWitUSData  }) {
    const mainSectionDevRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const isInView = (0,framer_motion__WEBPACK_IMPORTED_MODULE_3__/* .useInView */ .Y)(mainSectionDevRef, {
        once: true
    });
    const firstEl = (0,framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .useAnimation */ ._)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isInView) {
            firstEl.start("visible").catch(()=>{});
        }
    }, [
        isInView
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_5__/* .motion.section */ .E.section, {
        ref: mainSectionDevRef,
        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().bgStyle),
        variants: {
            visible: {
                y: [
                    150,
                    0
                ],
                opacity: [
                    0,
                    1
                ],
                transition: {
                    duration: 1.5
                }
            }
        },
        animate: firstEl,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: `font-bold 3xl:text-6xl lg:text-5xl text-3xl lg:leading-[54px] leading-9 ${partnerWitUSData.titleClassName ?? ""}`,
                children: partnerWitUSData.title
            }),
            partnerWitUSData.paragraphs.map((p, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: p.className === "default" ? "3xl:mt-6  mt-3 3xl:text-2xl  3xl:leading-10 lg:text-lg  3xl:max-w-[1040px] max-w-[740px]  font-light" : p.className,
                    children: p.text
                }, index)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "lg:mt-9 mt-12 w-fit ",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sharedButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    href: "/partner-with-us",
                    children: partnerWitUSData.buttonText
                })
            })
        ]
    });
}


/***/ }),

/***/ 96119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ResolvedForm; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);



const FormNew = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(33646), __webpack_require__.e(44268), __webpack_require__.e(26569), __webpack_require__.e(198), __webpack_require__.e(3294), __webpack_require__.e(15818), __webpack_require__.e(14086), __webpack_require__.e(47341)]).then(__webpack_require__.bind(__webpack_require__, 47341)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(47341)
            ]
    }
});
const FormOld = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(33646), __webpack_require__.e(44268), __webpack_require__.e(26569), __webpack_require__.e(198), __webpack_require__.e(3294), __webpack_require__.e(15818), __webpack_require__.e(14086), __webpack_require__.e(75108)]).then(__webpack_require__.bind(__webpack_require__, 75108)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(75108)
            ]
    }
});
function ResolvedForm(props) {
    const { loadOneToOneForm , domain  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    // The new form is the default for every domain. Keep the legacy form
    // available as an explicit per-domain escape hatch while one-to-one flows,
    // which are only implemented by the new form, always stay on FormNew.
    const useOldForm = !loadOneToOneForm && domain?.config?.forceOldForm === true;
    return useOldForm ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FormOld, {
        ...props
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FormNew, {
        ...props
    });
}


/***/ }),

/***/ 646:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bgStyle":"style_bgStyle__eUAiv","innerContainerStyle":"style_innerContainerStyle__yZ9xz","main-banner":"style_main-banner__S_Gij","form":"style_form__5mIpZ","steps-inner":"style_steps-inner__pUtnH","step-title":"style_step-title__gIFG2","label-as-step-title":"style_label-as-step-title__JIbZE","step-description":"style_step-description__8iB1I","form-button":"style_form-button__sbqUN","step-block":"style_step-block__bKD0E","form-field":"style_form-field__dwswP","field-label":"style_field-label___40Vv","radio-field":"style_radio-field__7fYS3","input-field":"style_input-field__kzHPz","checkbox-field":"style_checkbox-field__K1lYp","multiSelect-field":"style_multiSelect-field__0uXIy","select-field":"style_select-field__ueFXg","text-area-field":"style_text-area-field__qKWgA","tcpa":"style_tcpa__EM_p_","back-button":"style_back-button__mQW3H","error-style":"style_error-style__5xRC6","note-style":"style_note-style__gnmV7"};

/***/ }),

/***/ 38733:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bgStyle":"style_bgStyle__oR_IM"};

/***/ }),

/***/ 15791:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bgStyle":"style_bgStyle__Q2cMe","stepStyle":"style_stepStyle__W7lqI"};

/***/ }),

/***/ 56902:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"stepStyle":"style_stepStyle__FvDmt"};

/***/ }),

/***/ 68081:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"benefitItemStyle":"style_benefitItemStyle__sqYV4"};

/***/ }),

/***/ 41681:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imgStyle":"style_imgStyle__M_t7Y"};

/***/ }),

/***/ 57772:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"btnStyle":"style_btnStyle___YUoh"};

/***/ }),

/***/ 12658:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bgStyle":"style_bgStyle__n_Qd3"};

/***/ })

}]);